import { createFileRoute } from '@tanstack/react-router';
import { Home } from '~/features/home/Home';
import { NestedRouteErrorBoundary } from '~/components/errors/NestedRouteErrorBoundary';

export const Route = createFileRoute('/_auth/_home/_layout/home/')({
  component: Home,
  errorComponent: NestedRouteErrorBoundary,
});
